<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />
    <!-- tabla de datos -->
    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <!-- tabla -->
      <v-card>
        <v-card-title class="text-h5 font-weight-bold primary--text">
          <v-row>
            <v-col cols="2" sm="8">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    exact
                    color="primary"
                    class="mr-4"
                    v-bind="attrs"
                    v-on="on"
                    @click="regresar"
                  >
                    <v-icon> mdi-arrow-left </v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>
              Gestionar lideres -
              {{ competencia.competencia }}
            </v-col>

            <v-col cols="12" sm="4">
              <div class="d-flex align-center">
                <v-text-field
                  outlined
                  dense
                  append-icon="mdi-magnify"
                  label="Buscar Lider"
                  hide-details
                  class="mr-4"
                  v-model="searchTable"
                >
                </v-text-field>

                <v-btn exact color="primary" @click="open"> Registrar </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          fixed-header
          height="calc(100vh - 280px)"
          class="elevation-2"
          :headers="headersTable"
          :items="lideresCampesena"
          :search="searchTable"
          no-data-text="No hay lideres registrados"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >
          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="detalles(item.id)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>Detalles</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  color="primary"
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="editar(item.id)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Actualizar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="error"
                  v-bind="attrs"
                  v-on="on"
                  @click="alertaEliminar(item.id)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>
          <template v-slot:top>
            <v-dialog
              persistent
              scrollable
              max-width="520px"
              v-model="dialogForm"
            >
              <v-card :loading="loadingForm">
                <v-card-title class="justify-center">
                  <p class="text-h5 font-weight-bold primary--text">
                    {{ formTitle }}
                  </p>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="10">
                        <v-form ref="form" v-model="form">
                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Competencia"
                            v-model="competenciaSeleccionada"
                          >
                          </v-text-field>

                          <v-select
                            outlined
                            dense
                            :disabled="editedIndex === 1"
                            label="Categoría"
                            :items="categorias"
                            :rules="categoriaReglas"
                            item-value="id"
                            item-text="categoria"
                            v-model="categoria"
                            @change="obtenerSaberes"
                          ></v-select>

                          <v-select
                            outlined
                            dense
                            :disabled="editedIndex === 1"
                            label="Saber"
                            :items="saberes"
                            item-value="id"
                            item-text="saber"
                            v-model="saber"
                          ></v-select>
                          <v-select
                            outlined
                            dense
                            label="Tipo de Lider*"
                            :items="tiposLider"
                            item-value="id"
                            item-text="tipo_lider"
                            v-model="tipoLider"
                            :rules="tipoLiderReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Regional*"
                            :items="regionales"
                            item-value="id"
                            item-text="regional"
                            v-model="regional"
                            :rules="regionalReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Centro de Formación*"
                            :items="centrosFormacion"
                            item-value="id"
                            item-text="centro_formacion"
                            v-model="centroFormacion"
                            :rules="centroFormacionReglas"
                          >
                          </v-select>

                          <!-- Tipo y número de identificación -->
                          <v-select
                            outlined
                            dense
                            label="Tipo de Identificación*"
                            :items="tiposIdentificacion"
                            item-value="id"
                            item-text="tipo_identificacion"
                            v-model="tipoIdentificacion"
                            :rules="tipoIdentificacionReglas"
                          ></v-select>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Número de Identificación*"
                            v-model="identificacion"
                            :rules="identificacionReglas"
                          ></v-text-field>

                          <!-- Datos personales -->
                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Nombres*"
                            v-model="nombres"
                            :rules="nombresReglas"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Apellidos*"
                            v-model="apellidos"
                            :rules="apellidosReglas"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Correo Electrónico*"
                            maxlength="50"
                            counter
                            v-model="correo"
                            :rules="correoReglas"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            label="Teléfono Móvil*"
                            maxlength="10"
                            counter
                            v-model="telefonoMovil"
                            :rules="telefonoMovilReglas"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Dirección*"
                            maxlength="50"
                            counter
                            v-model="direccion"
                            :rules="direccionReglas"
                          ></v-text-field>

                          <!-- Fecha de nacimiento -->
                          <v-dialog
                            ref="fechaNacimiento"
                            persistent
                            width="300px"
                            v-model="dialogFechaNacimiento"
                            :return-value.sync="fechaNacimiento"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                outlined
                                dense
                                readonly
                                prepend-inner-icon="mdi-calendar"
                                label="Fecha de Nacimiento*"
                                v-model="fechaNacimiento"
                                :rules="fechaNacimientoReglas"
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>

                            <v-date-picker
                              scrollable
                              locale="es"
                              color="primary"
                              v-model="fechaNacimiento"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="error"
                                @click="dialogFechaNacimiento = false"
                                >Cancelar</v-btn
                              >
                              <v-btn
                                text
                                color="primary"
                                @click="
                                  $refs.fechaNacimiento.save(fechaNacimiento)
                                "
                                >OK</v-btn
                              >
                            </v-date-picker>
                          </v-dialog>

                          <!-- Género -->
                          <v-select
                            outlined
                            dense
                            label="Género*"
                            :items="generos"
                            item-value="id"
                            item-text="genero"
                            v-model="genero"
                            :rules="generoReglas"
                          ></v-select>

                          <!-- estados civiles -->
                          <v-select
                            outlined
                            dense
                            label="Estado Civil*"
                            :items="estadosCiviles"
                            item-value="id"
                            item-text="estado_civil"
                            v-model="estadoCivil"
                            :rules="estadoCivilReglas"
                          ></v-select>

                          <!-- estrato -->
                          <v-select
                            outlined
                            dense
                            label="Estrato*"
                            :items="estratos"
                            item-value="id"
                            item-text="estrato"
                            v-model="estrato"
                            :rules="estratoReglas"
                          ></v-select>

                          <!-- zona -->
                          <v-select
                            outlined
                            dense
                            label="Zona*"
                            :items="zonas"
                            item-value="id"
                            item-text="zona"
                            v-model="zona"
                            :rules="zonaReglas"
                          ></v-select>

                          <!-- discapacidad -->
                          <v-select
                            outlined
                            dense
                            label="Discapacidad*"
                            :items="discapacidades"
                            item-value="id"
                            item-text="discapacidad"
                            v-model="discapacidad"
                            :rules="discapacidadReglas"
                          ></v-select>

                          <!--Tipo de Alimentación -->
                          <v-select
                            outlined
                            dense
                            label="Tipo de Alimentación*"
                            :items="tipoAlimentacion"
                            item-value="id"
                            item-text="tipo_alimentacion"
                            v-model="tiposAlimentacion"
                            :rules="tipoAlimentacionReglas"
                          ></v-select>

                          <!-- Restricción alimentaria -->
                          <v-select
                            outlined
                            dense
                            label="¿Tiene restricción alimentaria?"
                            :items="restriccionesAlimentarias"
                            item-value="valor"
                            item-text="texto"
                            v-model="restriccionAlimentaria"
                            :reglas="restriccionAlimentariaReglas"
                          ></v-select>

                          <v-text-field
                            v-if="restriccionAlimentaria"
                            outlined
                            dense
                            label="Descripción restricción alimentaria"
                            v-model="descripcionRestriccionAlimentaria"
                          ></v-text-field>

                          <!-- Enfermedad existente -->
                          <v-select
                            outlined
                            dense
                            label="¿Tiene alguna enfermedad existente?"
                            :items="enfermedadesExistentes"
                            item-value="valor"
                            item-text="texto"
                            v-model="enfermedadExistente"
                            :reglas="enfermedadExistenteReglas"
                          ></v-select>

                          <v-text-field
                            v-if="enfermedadExistente"
                            outlined
                            dense
                            label="Descripción enfermedad existente"
                            v-model="descripcionEnfermedadExistente"
                          ></v-text-field>

                          <!-- talla camiseta -->
                          <v-select
                            outlined
                            dense
                            label="Talla de Camiseta*"
                            :items="tallas"
                            v-model="talla"
                            :rules="tallaReglas"
                          ></v-select>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="close"> Cancelar </v-btn>

                  <template v-if="editedIndex === -1">
                    <v-btn text exact color="primary" @click="registrar">
                      Registrar
                    </v-btn>
                  </template>

                  <template v-else>
                    <v-btn text exact color="primary" @click="actualizar">
                      Actualizar
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="dialogDelete" max-width="400px">
        <v-card>
          <v-card-title class="text-h6 text-md-h5 justify-center">
            ¿Desea eliminar el lider?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="closeDelete"> Cancelar </v-btn>
            <v-btn text color="error" @click="eliminar"> OK </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import Alert from "../../../components/admin/Alert.vue";

export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,
    loadingTextField: false,

    alert: false,
    alertType: "",
    alertTitle: "",
    alertMessage: "",

    loadingForm: false,
    form: true,

    dialogForm: false,
    loadingFormImportar: false,
    formImportar: true,
    dialogFormImportar: false,

    archivoLideres: null,

    dialogDelete: false,

    competenciaSeleccionada: "",
    personaId : null,

    genero: null,
    generoReglas: [(v) => !!v || "Seleccione un genero"],
    generos: [
      { genero: "Femenino", id: 1 },
      { genero: "Masculino", id: 2 },
      { genero: "No Binario", id: 3 },
    ],
    estadoCivil: null,
    estadoCivilReglas: [(v) => !!v || "Seleccione un estado civil"],

    estrato: null,
    estratoReglas: [(v) => !!v || "Seleccione un estrato"],
    estratos: [
      { estrato: 1, id: 1 },
      { estrato: 2, id: 2 },
      { estrato: 3, id: 3 },
      { estrato: 4, id: 4 },
      { estrato: 5, id: 5 },
      { estrato: 6, id: 6 },
    ],

    zona: null,
    zonaReglas: [(v) => !!v || "Seleccione una zona"],
    zonas: [
      { zona: "Urbana", id: 1 },
      { zona: "Rural", id: 2 },
    ],

    tiposAlimentacion: null,
    tipoAlimentacionReglas: [
      (v) => !!v || "Seleccione un tipo de alimentación",
    ],

    discapacidad: null,
    discapacidadReglas: [(v) => !!v || "Seleccione una discapacidad"],

    talla: null,
    tallas: ["XS", "S", "M", "L", "XL", "XXL", "3XL"],
    tallaReglas: [(v) => !!v || "Seleccione una talla"],

    
    tipoLider: null,
    tipoLiderReglas: [
      (v) => !!v || "Seleccione un tipo de lider"
    ],

    saber: null,
    saberesReglas: [(v) => !!v || "Selecciona un saber"],

    categoria: null,
    categoriaReglas: [(v) => !!v || "Seleccione una categoria"],

    regional: null,
    regionalReglas: [(v) => !!v || "Seleccione una regional"],

    centroFormacion: null,
    centroFormacionReglas: [(v) => !!v || "Seleccione un centro de formación"],

    descripcionEnfermedadExistente: null,
    enfermedadExistente: null,
    enfermedadExistenteReglas: [(v) => !!v || "Seleccione una valor"],
    enfermedadesExistentes: [
      { texto: "Sí", valor: true },
      { texto: "No", valor: false },
    ],
    
    descripcionRestriccionAlimentaria: null,
    restriccionAlimentaria: null,
    restriccionAlimentariaReglas: [(v) => !!v || "Seleccione una valor"],
    restriccionesAlimentarias: [
      { texto: "Sí", valor: true },
      { texto: "No", valor: false },
    ],

    idPersona: null,
    tipoIdentificacion: null,
    tipoIdentificacionReglas: [
      (v) => !!v || "Seleccione un tipo de Identififcacion",
    ],
    
    tiposIdentificacion: [
      { tipo_identificacion: "Tarjeta de Identidad", id: 1 },
      { tipo_identificacion: "Cedula de Ciudadania", id: 2 },
      { tipo_identificacion: "Documento Extranjero", id: 3 },
    ],
    
    identificacion: null,
    identificacionReglas: [
      (v) => !!v || "Escriba un número de identificación",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos",
      (v) => (v && v.length >= 6) || "Minimo 6 digitos",
    ],
    mensajeIdentificacion: "",
    
    nombres: null,
    nombresReglas: [(v) => !!v || "Escriba los nombres"],
    
    apellidos: null,
    apellidosReglas: [(v) => !!v || "Escriba los apellidos"],
    
    correo: null,
    correoReglas: [
      (v) => !!v || "Escriba un correo electrónico",
      (v) => /.+@.+\..+/.test(v) || "Correo electrónico no válido",
    ],
    
    telefonoMovil: null,
    telefonoMovilReglas: [
      (v) => !!v || "Escriba un número de telefono movil",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos",
    ],
    
    direccion: null,
    direccionReglas: [(v) => !!v || "Escriba una dirección"],
    
    dialogFechaNacimiento: false,
    fechaNacimiento: null,
    fechaNacimientoReglas: [(v) => !!v || "Seleccione una fecha"],

    liderId: null,

    headersTable: [
      {
        text: "Identificación",
        value: "identificacion",
        align: "start",
        width: "10%",
        sortable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Nombres",
        value: "nombres",
        width: "15%",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Apellidos",
        value: "apellidos",
        width: "15%",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Correo Electrónico",
        value: "correo",
        align: "start",
        width: "15%",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Centro de Formación",
        value: "centro_formacion",
        align: "start",
        width: "30%",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ],

    editedIndex: -1,
  }),

  components: {
    Alert,
  },
  mounted() {
    this.$store.dispatch("crearEstadosCiviles");
    this.$store.dispatch("crearDiscapacidades");
    this.$store.dispatch("crearTipoAlimentacion");
    this.$store.dispatch("crearTiposLider");
    this.$store.dispatch("gestionarSaberesCompetencia",this.$route.params.idCompetencia);
    this.$store.dispatch("gestionarCategoriasCampesena");
    this.$store.dispatch("crearRegionales");
    this.$store.dispatch("crearCentrosFormacion");
    this.$store.dispatch( "gestionarlideresCampesena", this.$route.params.idCompetencia);
    this.$store.dispatch("obtenerCompetenciaCampesenaId",this.$route.params.idCompetencia);

    setTimeout(() => {
      const data = this.competencia;
      this.competenciaSeleccionada = data.competencia;
      this.skeletonLoader = false;
    }, 1000);
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Registrar Lider" : "Actualizar Lider";
    },

    tipoAlimentacion() {
      return this.$store.getters.obtenerTipoAlimentacion;
    },

    discapacidades() {
      return this.$store.getters.obtenerDiscapacidades;
    },

    estadosCiviles() {
      return this.$store.getters.obtenerEstadosCiviles;
    },

    competencia() {
      return this.$store.getters.obtenerCompetenciaCampesena;
    },

    lideresCampesena() {
      return this.$store.getters.obtenerLideresCampesena;
    },

    lider() {
      return this.$store.getters.obtenerLiderCampesena;
    },
    saberes() {
      return this.$store.getters.obtenerSaberes;
    },

    categorias() {
      return this.$store.getters.obtenerCategoriasCampesena;
    },

    regionales() {
      return this.$store.getters.obtenerRegionales;
    },

    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacion(this.regional);
    },

    tiposLider() {
      return this.$store.getters.obtenerTiposLiderCampesena(8);
    },
  },

  watch: {
    dialogForm(val) {
      val || this.close();
    },

    dialogFormImportar(val) {
      val || this.closeImportar();
    },

    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    open() {
      this.editedIndex = -1
      this.dialogForm = true;
      this.competenciaSeleccionada = this.competencia.competencia;
    },

 
    detalles(idLider) {
      this.$router.push({
        name: "campesena-competencia-lider-detalles",
        params: { idLider: idLider },
      });
    },


    close() {
      this.dialogForm = false;
      this.$refs.form.reset();
      this.mensajeIdentificacion = "";
    },

    alertaEliminar(lider) {
      this.liderId = lider;
      this.dialogDelete = true;
    },
    eliminar() {
      this.dialogDelete = false;
    
      this.$store
        .dispatch("eliminarLiderCampesena", this.liderId)
        .then((response) => {
          if (response.status == "success") {
            let message = response.message.split(",");
            this.alert = true;
            this.alertTitle = message[0];
            this.alertMessage = message[1];
            this.alertType = "success--text";
    
            this.skeletonLoader = true;
    
            this.$store.dispatch(
              "gestionarlideresCampesena",
              this.$route.params.idCompetencia
            );
    
            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false;
            }, 2000);
          } else {
            this.loadingForm = false;
            this.alertType = "error--text";
            this.alertTitle = "Error";
    
            for (const error in response.message) {
              this.alertMessage = response.message[error][0];
            }
    
            this.alert = true;
    
            setTimeout(() => {
              this.alert = false;
            }, 3000);
          }
        })
        .catch(() => {});
    },
    
    closeDelete() {
      this.dialogDelete = false;
      this.editedIndex = -1;
    },



    registrar() {
      if (this.$refs.form.validate()) {
          const nombresPersona = this.nombres.trim().split(" ");
          const apellidosPersona = this.apellidos.trim().split(" ");
          const liderCampesena = {
            competencia_id: this.$route.params.idCompetencia,
            saber_id: this.saber,
            tipo_lider_id: this.tipoLider,
            centro_formacion_id:    this.centroFormacion,
            tipo_identificacion_id: this.tipoIdentificacion,
            identificacion: this.identificacion,
            primer_nombre: nombresPersona[0],
            segundo_nombre: nombresPersona[1],
            primer_apellido: apellidosPersona[0],
            segundo_apellido: apellidosPersona[1],
            correo: this.correo,
            telefono_movil: this.telefonoMovil,
            direccion: this.direccion,
            fecha_nacimiento: this.fechaNacimiento,
            edad: Math.floor(
              (new Date() - new Date(this.fechaNacimiento)) /
                (365.25 * 24 * 60 * 60 * 1000)
            ),
            genero_id: this.genero,
            estado_civil_id: this.estadoCivil,
            estrato: this.estrato,
            zona_id: this.zona,
            discapacidad_id: this.discapacidad,
            tipo_alimentacion_id: this.tiposAlimentacion,
            restriccion_alimentaria: this.restriccionAlimentaria,
            descripcion_restriccion_alimentaria: this.descripcionRestriccionAlimentaria,
            enfermedad_existente: this.enfermedadExistente,
            descripcion_enfermedad_existente: this.descripcionEnfermedadExistente,
            talla_camiseta: this.talla,
          };
          
          this.loadingForm = true;

          this.$store
            .dispatch("registrarLideresCampesena", liderCampesena)
            .then((response) => {
              if (response.status == "success") {
                let message = response.message.split(",");
                this.loadingForm = false;
                this.alertTitle = message[0];
                this.alertMessage = message[1];
                this.alertType = "success--text";
                this.alert = true;

                this.skeletonLoader = true;

                this.$store.dispatch(
                  "gestionarlideresCampesena",
                  this.$route.params.idCompetencia
                );
                this.close();

                setTimeout(() => {
                  this.alert = false;
                  this.skeletonLoader = false;
                }, 2000);
              } else {
                this.loadingForm = false;
                this.alert = true;
                this.alertTitle = "Error";
                this.alertType = "error--text";
                for (const error in response.message) {
                  this.alertMessage = response.message[error][0];
                }
              }

              setTimeout(() => {
                this.alert = false;
              }, 3000);
            })
            .catch(() => {});
      }
    },
    editar(idLider) {
      this.dialogForm = true;
      this.editedIndex = 1;
      this.liderId = idLider;

      
      this.$store.dispatch("obtenerCampesenaLiderId", idLider);
      setTimeout(() => {
        const response = this.lider;
        this.competenciaSeleccionada = response.competencia;
        this.regional = response.regional_id;
        this.categoria= response.categoria_id;
        this.saber = response.saber_id;
        this.tipoLider= response.tipo_lider_id
        this.centroFormacion = response.centro_formacion_id;
        this.personaId = response.persona_id;
        this.tipoIdentificacion = response.tipo_identificacion;
        this.identificacion = response.identificacion;
        this.nombres = response.nombres;
        this.apellidos = response.apellidos;
        this.telefonoMovil = response.telefono_movil;
        this.direccion = response.direccion;
        this.fechaNacimiento = response.fecha_nacimiento;
        this.genero = response.genero_id;
        this.estadoCivil = response.estado_civil;
        this.estrato = response.estrato;
        this.zona = response.zona;
        this.discapacidad = response.discapacidad;
        this.correo = response.correo;
        this.talla = response.talla_camiseta;
        this.idPersona = response.persona_id;
        this.tiposAlimentacion = response.tipo_alimentacion_id;
        this.restriccionAlimentaria = response.restriccion_alimentaria;
        this.descripcionRestriccionAlimentaria = response.descripcion_restriccion_alimentaria;
        this.enfermedadExistente = response.enfermedad_existente;
        this.descripcionEnfermedadExistente =response.descripcion_enfermedad_existente;
        this.obtenerSaberes();
       
      }, 1000)
    },

    obtenerSaberes() {
      this.$store.dispatch("gestionarSaberesCampesena", this.categoria);
    },

    actualizar() {
      if (this.$refs.form.validate()) {
        const nombresPersona = this.nombres.trim().split(" ");
        const apellidosPersona = this.apellidos.trim().split(" ");

        const lider = {
          competencia_id: this.$route.params.idCompetencia,
          saber_id: this.saber,
          tipo_lider_id: this.tipoLider,
          centro_formacion_id:    this.centroFormacion,
          persona_id: this.personaId,
          tipo_identificacion_id: this.tipoIdentificacion,
          identificacion: this.identificacion,
          primer_nombre: nombresPersona[0],
          segundo_nombre: nombresPersona[1],
          primer_apellido: apellidosPersona[0],
          segundo_apellido: apellidosPersona[1],
          correo: this.correo,
          telefono_movil: this.telefonoMovil,
          direccion: this.direccion,
          fecha_nacimiento: this.fechaNacimiento,
          edad: Math.floor(
            (new Date() - new Date(this.fechaNacimiento)) /
              (365.25 * 24 * 60 * 60 * 1000)
          ),
          genero_id: this.genero,
          estado_civil_id: this.estadoCivil,
          estrato: this.estrato,
          zona_id: this.zona,
          discapacidad_id: this.discapacidad,
          tipo_alimentacion_id: this.tiposAlimentacion,
          restriccion_alimentaria: this.restriccionAlimentaria,
          descripcion_restriccion_alimentaria: this.descripcionRestriccionAlimentaria,
          enfermedad_existente: this.enfermedadExistente,
          descripcion_enfermedad_existente: this.descripcionEnfermedadExistente,
          talla_camiseta: this.talla,
        };
        this.loadingForm = true;

        this.$store
          .dispatch("actualizarliderCampesena", {
            liderId: this.liderId,
            lider: lider,
          })
          .then((response) => {
            if (response.status == "success") {
              this.close();
              this.loadingForm = false;
              const message = response.message.split(",");
              this.alertType = "success--text";
              this.alertTitle = message[0];
              this.alertMessage = message[1];
              this.alert = true;

              this.skeletonLoader = true;
              this.$store.dispatch(
                "gestionarlideresCampesena",
                this.$route.params.idCompetencia
              );

              setTimeout(() => {
                this.alert = false;
                this.skeletonLoader = false;
              }, 1000);
            } else {
              this.loadingForm = false;
              this.alertType = "error--text";
              this.alertTitle = "Error";

              for (const error in response.message) {
                this.alertMessage = response.message[error][0];
              }

              this.alert = true;

              setTimeout(() => {
                this.alert = false;
              }, 3000);
            }
          })
          .catch(() => {});
      }
    },


    regresar() {
      this.$router.push({
        name: "competencia-gestionar",
      });
    },
  }
};
</script>
